export default "__VITE_ASSET__CQOmWtHD__"